import { createGlobalStyle } from 'styled-components'

const StyledTour = createGlobalStyle`
  .tour-reward {
    position: fixed;
    top: -250px;
    left: 50%;
    pointer-events: none;
    transform: translateX(-50%);
    z-index: 9999999;
  }

  .shepherd-element{
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 6px;
    box-shadow: 0px 0px 0px 1px rgba(17, 24, 39, 0.1), 0px 2px 4px rgba(17, 24, 39, 0.1);
    max-width: 360px;
    opacity: 0;
    outline: none;
    transition: opacity 0.3s, visibility 0.3s;
    visibility: hidden;
    width: 100%;
    z-index: 9999;

    .shepherd-content {
      .shepherd-header {
        .shepherd-cancel-icon {
          position: absolute;
          top: 18px;
          right: 18px;
          padding: 0;
          width: 26px;
          height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          border-radius: 6px;
          border: 0;
          transition: 0.2s;
          color: ${({ theme }) => theme.colors.gray[900]}60;
          background-color: transparent;

          &:hover {
            cursor: pointer;
            background-color: ${({ theme }) => theme.colors.background}50;
            color: ${({ theme }) => theme.colors.gray[900]}cc;
          }
        }
      }

      .shepherd-text {
        img {
          height: 125px;
          object-fit: cover;
          width: calc(100% + 36px + 25px + 25px);
          border-radius: 6px 6px 0 0;
          margin: -25px -25px 18px -25px;
        }

        .centered-text {
          text-align: center;
          display: block;
          margin-right: -36px;
        }

        padding: 25px;
        box-sizing: border-box;
        width: calc(100% - 36px);
        font-size: 1rem;
        font-weight: 500;
        line-height: 22px;
        color: ${({ theme }) => theme.colors.gray[800]};
      }
      
      .shepherd-footer {
        padding: 25px;
        display: flex;
        justify-content: end;
        align-items: center;

        .step-progress {
          margin-right: auto;
          font-size: 14px;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.gray[500]};
          user-select: none;
        }

        button {
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.2s;
          border-radius: 6px;
          padding: 0 12px;
          min-width: 70px;
          font-weight: 600;
          user-select: none;
          border: 1px solid ${({ theme }) => theme.colors.gray[400]};
          background-color: ${({ theme }) => theme.colors.background};
          color: ${({ theme }) => theme.colors.gray[800]};

          &:not(:last-child) {
            margin-right: 10px;
          }
    
          &:hover {
            cursor: pointer;
            background-color: ${({ theme }) => theme.colors.gray[100]};
          }

          &:last-child {
            border: 1px solid ${({ theme }) => theme.colors.green[600]};
            background-color: ${({ theme }) => theme.colors.green[500]};
            color: ${({ theme }) => theme.colors.background};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[600]};
            }
          }
        }
      }
    }

    &.shepherd-enabled {
      opacity:1;
      visibility:visible
    }

    &[data-popper-reference-hidden]:not(.shepherd-centered){
      opacity:0;
      pointer-events:none;
      visibility:hidden
    }
  }

  .shepherd-modal-overlay-container{
    height: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: all .3s ease-out, height 0ms .3s, opacity .3s 0ms;
    width: 100vw;
    z-index: 9999;

    &.shepherd-modal-is-visible {
      height: 100vh;
      opacity: 0.5;
      transition: all .3s ease-out, height 0s 0s, opacity .3s 0s;

      path {
        pointer-events: all;
      }
    }
  }

  .shepherd-target-click-disabled {
    pointer-events: none !important;
    cursor: default;
  }
`

export default StyledTour
